// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_45-0";
export var orangeButton = "_45-1";